import React from 'react'
import numeral from 'numeral'
import { Icon } from 'semantic-ui-react'

const AppraisalSummary = ({data}) =>
{
  const copyTextStyle = {cursor: "pointer"}
  const copyPrice = () => {
    navigator.clipboard.writeText(data.total_price);
  }

  const copyQuote = () => {
    navigator.clipboard.writeText(data.id);
  }

  return (
    <div style={{textAlign:'right'}}>
      Volume: {numeral(data.total_volume).format('0,0.00')} m3<br />
      Jita Sell: {numeral(data.total_sell).format('0,0.00')} ISK<br />
      Jita Buy: {numeral(data.total_buy).format('0,0.00')} ISK<br />
      Buyback Price: <a onClick={copyPrice} style={copyTextStyle}>{numeral(data.total_price).format('0,0.00')} ISK<Icon link name='copy outline' /></a><br />
      Quote Number: <a onClick={copyQuote} style={copyTextStyle}>{data.id}<Icon link name='copy outline' /></a>
    </div>
  )
}

export default AppraisalSummary
